import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';

/**
 * Applies the persisted UI theme to the document root by toggling the `dark`
 * class Tailwind's `darkMode: 'class'` keys off. Resolves 'system' against the
 * OS preference and keeps following it live while 'system' is selected.
 * Mount once at the app shell (AppLayout). A no-flash init script in index.html
 * sets the initial class before paint; this keeps it in sync as the store changes.
 */
export function useApplyTheme() {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && mq.matches);
      root.classList.toggle('dark', dark);
    };
    apply();
    if (theme === 'system') {
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [theme]);
}
